// FR-4 §"Key specs table" — renders the `specs` JSON column as a two-
// column table. Hidden entirely when no specs are configured so the
// type page doesn't show an empty section.
export interface SpecsTableProps {
  specs: Record<string, string> | null | undefined;
}

export function SpecsTable({ specs }: SpecsTableProps): JSX.Element | null {
  const entries = specs ? Object.entries(specs).filter(([k]) => k.trim().length > 0) : [];
  if (entries.length === 0) return null;
  return (
    <table className="w-full border-collapse text-sm">
      <caption className="sr-only">Equipment specifications</caption>
      <tbody className="divide-y divide-zinc-100">
        {entries.map(([key, value]) => (
          <tr key={key}>
            <th scope="row" className="w-1/2 py-2 pr-3 text-left font-medium text-zinc-600">
              {key}
            </th>
            <td className="py-2 text-brand-black">{value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
